module.exports = __webpack_public_path__ + "img/ledmidia.3325615c.png";